import React from 'react';
import {UserTotalPanel} from "../UserTotalPanel";
import {riskTypeIdentifiers} from "../../../routes";
import {RiskRowBox} from "./RiskRowBox";
import {useQueryWithAccessToken} from "../../../hooks/TanstackHooks";
import {cacheKeys} from "../../../services/shared/serviceConstants";
import {getPanelLink, usersFromQuery} from "../DashboardPanels/panelCommon";
import {getGhosts} from "../../../services/shared/Ghosts";

export interface GhostUserCountProps {
  sot: any;
  numberInCircle: number;
}
export const GhostUserCount = (props: GhostUserCountProps) => {
  const {sot, numberInCircle} = props;

  const fullQuery = useQueryWithAccessToken({
      queryKey: [cacheKeys.ghosts],
      queryFunction: getGhosts,
      queryFunctionVariables:{sot},
      tanstackOptions:{
        enabled: !!sot  // Don't execute the query if there is no SoT
      }
    }
  )

  // If there's a SoT then run the query, if not supply placeholder values to the UI
  const {isLoading, count, users, isError} = sot ? usersFromQuery(fullQuery)
    : {
      isLoading : false,
      count : 0,
      users : [],
      isError: false,
  };


  return (<RiskRowBox>
    <UserTotalPanel
      count={count}
      users={users}
      riskName="Ghost Users"
      riskDescription={<span><em>Users without an active account in your source of truth, <strong>{sot?.name}</strong></em></span>}
      viewAllUrl={getPanelLink(riskTypeIdentifiers.ghosts, count)}
      numberInCircle={numberInCircle}
      largeMode={false}
      isLoading={isLoading}
      isError={isError}
    />
  </RiskRowBox>)
};
